<template>
  <div id="app" class="relative">
    <shopping-bag v-if="showShoppingBag"></shopping-bag>
    <div :class="containerClass()">
      <div class="flex w-screen" :class="setEnterAnimation()">
        <app-menu @close-menu="openMenu = false" />
        <section class="flex flex-col justify-between items-center w-screen">
          <div class="flex flex-col mx-auto w-screen lg:w-7/12">
            <header id="nav" class="text-center z-10">
              <header-salvi v-show="$route.path!=='/404' && $route.path!== '/503'" @open-menu="openMenu = true; start = false" />
            </header>
            <div v-if="banner" class="w-full bg-yellow-400 text-center mt-5 py-2 px-20">
              {{ banner.text }}
            </div>
            <main class="flex-grow min-h-screen h-auto w-full md:w-11/12 lg:w-full mx-auto">
            <router-view />
            </main>
            <footer id="footer" class="block lg:hidden">
              <footer-salvi v-show="$route.path!=='/404' && $route.path!== '/503'" />
            </footer>
          </div>
          <footer class="hidden lg:block xl:block">
            <footer-salvi-desktop v-show="$route.path!=='/404' && $route.path!== '/503'"/>
          </footer>
        </section>
      </div>
    </div>

    <modal name="add-harp" height="auto" :adaptive="true">
      <div class="p-6 bg-gray-200 text-center">
        <h3 class="font-bold uppercase text-2xl">{{$t('userData.haveHarps')}}</h3>
        <h5>{{$t('userData.addHarps')}}</h5>
        </div>
        <user-harps class="p-6" @close="updateConfiguratorAfterHarpIsAdded()" />
    </modal>

    <modal name="generic">
    </modal>

    <notifications-container class="z-30" />

    <v-dialog name="not-found-product" class="text-center" />

  <!--   <cookie-law theme="blood-orange" :buttonText="$t('footer.cookie-button')">
      <div slot="message">
        {{$t('footer.cookie-banner')}}
        <button class="font-bold cursor-pointer" @click="openCookiePolicy">{{$t('footer.here')}}</button>.
      </div>
    </cookie-law> -->

    <div class="flex justify-left fixed w-full top-0 left-0" v-if="showWhyDiscount" :style="getMousePosition()">
      <div class="p-4 rounded px-6 bg-yellow-500 flex justify-center w-40" >
        <h4> {{$t('notifications.whyDiscount')}} {{ `${this.customer.customer_group.name}`}} </h4>
      </div>
    </div>

  </div>
</template>

<script>
import HeaderSalvi from '@/components/graphics/HeaderSalvi.vue';
import FooterSalvi from '@/components/graphics/FooterSalvi.vue';
import FooterSalviDesktop from '@/components/graphics/FooterSalviDesktop.vue';
import ShoppingBag from '@/components/ShoppingBag.vue';
import AppMenu from '@/components/AppMenu.vue';
import NotificationsContainer from '@/components/notifications/NotificationsContainer.vue';
import UserHarps from '@/components/profile/UserHarps.vue';
import axios from 'axios';

import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      start: true,
      openMenu: false,

      title: this.$t('titles.default'),

      banner: null,
    };
  },

  components: {
    HeaderSalvi,
    FooterSalvi,
    FooterSalviDesktop,
    ShoppingBag,
    AppMenu,
    NotificationsContainer,
    UserHarps,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      totalWithTaxes: 'cart/totalWithTaxes',
      customer: 'auth/customer',
      showWhyDiscount: 'notification/showWhyDiscount',
      mouseXPosition: 'notification/mouseXPosition',
      mouseYPosition: 'notification/mouseYPosition',
      changedLocale: 'auth/changedLocale',
    }),

    showShoppingBag() {
      return this.$store.state.showShoppingBag;
    },
    showSideMenu() {
      return this.$store.state.showSideMenu;
    },

  },

  watch: {
    authenticated() {
      if (this.authenticated) {
        this.$store.dispatch('cart/updateProductsDiscountRate');
      }
    },
    changedLocale() {
      this.getCurrentBanner();
    },
  },

  created() {
    this.getCurrentBanner();
  },

  methods: {
    ...mapActions({
      toggleMenu: 'toggleMenu',
    }),

    setEnterAnimation() {
      if (this.openMenu) return 'animate-translate-in-menu';
      if (!this.openMenu && !this.start) return 'animate-translate-out-menu transform -translate-x-full';
      return 'transform -translate-x-full';
    },

    updateConfiguratorAfterHarpIsAdded() {
      this.$modal.hide('add-harp');
    },

    containerClass() {
      if (this.openMenu) return 'max-w-screen h-screen overflow-hidden';
      return 'overflow-hidden';
    },

    openCookiePolicy() {
      axios.get('/api/cookie-policy')
        .then(({ data }) => {
          window.location.href = data.url;
        });
    },

    getMousePosition() {
      return `margin-left: ${this.mouseXPosition - 150}px; margin-top: ${this.mouseYPosition + 20}px;`;
    },

    getCurrentBanner() {
      axios.get('/api/banners/current').then(({ data }) => {
        this.banner = data;
      });
    },
  },
};
</script>

<style lang="scss">
#app {
  @apply font-sans-serif; @apply text-blackish;
}

#nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
  @apply font-sans-serif;
}

  .ql-toolbar {
    display: none;
  }

  .ql-container.ql-snow {
    border: 0px !important;
  }

  .ql-container {
        font-family: Raleway, sans-serif !important;
    }

  .ais-Hits-item {
    padding: 0rem;
    width: calc(33% - 1rem);
    border: 0px;
    box-shadow: none;
  }

@media screen and (max-width: 600px) {
  .ais-Hits-item {
    padding: 0rem;
    width: calc(50% - 1rem);
    border: 0px;
    box-shadow: none;
  }
}
</style>
